import { Button, Card, CardBody, CardFooter, Typography } from "@material-tailwind/react";
import { Modal } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";
import { api } from "../../../../../services/api/api";
import { showApiErrorToast } from "../../../../../services/api/error";
import Loading from "../../../../../components/loading/Loading";

export default function DeleteCustomerModal({
  open,
  customer,
  onDelete,
  onClose
}: {
  open: boolean,
  customer: EasyTech.Customer,
  onDelete: () => void,
  onClose: () => void
}) {
  const [delLoad, setDelLoad] = useState(false);

  const deleteCustomer = () => {
    setDelLoad(true);
    api.put(`admin/customers/disable/${customer.id}`, {})
      .then(() => {
        toast.success(t("admin:customers.messages.deleteSuccess"));
        onDelete();
      }).catch((err) => {
        showApiErrorToast(err, { fallbackMessage: t("admin:customers.errors.delete") });
      }).finally(() => {
        setDelLoad(false);
        onClose();
      });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="te-modal"
      aria-labelledby="te-modal"
      aria-describedby="te-modal"
    >
      <Card className="te-modal-content rounded-lg">
        <button className="close-button" onClick={() => onClose()}>
          <XMarkIcon className="w-4" />
        </button>
        <CardBody>
          <div className="flex items-center gap-3 mb-5">
            <div className="rounded-full border p-2 bg-red-200">
              <TrashIcon className="w-7 text-red-700" />
            </div>
            <Typography variant="h5">
              {t("admin:customers.delete.title", { name: customer.name })}
            </Typography>
          </div>
          <Typography variant="paragraph">
            {t("admin:customers.delete.description")}
          </Typography>
        </CardBody>
        <CardFooter className="pt-0 flex gap-2 justify-end">
          <Button variant="outlined" onClick={onClose}>
            {t("common:cancel")}
          </Button>
          {delLoad ? (
            <Loading />
          ) : (
            <Button color="blue" onClick={deleteCustomer}>
              {t("common:delete")}
            </Button>
          )}
        </CardFooter>
      </Card>
    </Modal>
  );
}
